module.exports = __webpack_public_path__ + "media/img/help_center/Student_Test_10-cdc6ec5552a5f85e1d6f432c925210d8.jpg";